
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/about",
      function () {
        return require("private-next-pages/product/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/about"])
      });
    }
  